import ProgressBarPopUp from './ProgressBarPopUp-redux';

export default ProgressBarPopUp;
